import app from 'firebase/app'

import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/performance'


const config = {
    apiKey: "AIzaSyBsKUeT3pTey2Wuu_a87XA2pS4c0PVd2S4",
    authDomain: "gestion-gourmets.firebaseapp.com",
    projectId: "gestion-gourmets",
    storageBucket: "gestion-gourmets.appspot.com",
    messagingSenderId: "123502112006",
    appId: "1:123502112006:web:2a4ba38a14b1e830c08287"
};

class Firebase {
    constructor() {
        app.initializeApp(config)
        this.auth = app.auth()
        this.db = app.firestore()
        this.performance = app.performance()
    }

    //login
    loginUser = (email, password) => this.auth.signInWithEmailAndPassword(email, password)

    //logout
    logoutUser = () => this.auth.signOut()

    //forget password
    passwordReset = email => this.auth.sendPasswordResetEmail(email)

    //get user infos
    user = uid => this.db.doc(`users/${uid}`)

    //add a customer
    newCustomer = (uid, CustomerData) => this.db.collection('users').doc(`${uid}`).collection('customer').doc(`${CustomerData.name}`).set(CustomerData)

    //update customer
    updateCustomer = (uid, CustomerData) => this.db.collection('users').doc(`${uid}`).collection('customer').doc(`${CustomerData.name}`).update(CustomerData)

    //delete a customer
    delCustomer = (uid, name) => this.db.collection('users').doc(`${uid}`).collection('customer').doc(`${name}`).delete()
    
    //Get customers
    getCustomers = uid => this.db.collection(`users/${uid}/customer`)

    //get customer infos
    getCustomerInfos = (uid, name) => this.db.doc(`users/${uid}/customer/${name}`)

    //add new menu week
    newMenuWeek = (uid, week, MenuData) => this.db.collection('users').doc(`${uid}`).collection('menus').doc(`${week}`).set(MenuData)

    // delete menu week
    deleteMenuWeek = (uid, week) => this.db.collection('users').doc(`${uid}`).collection('menus').doc(`${week}`).delete()

    //get menus
    getMenus = uid => this.db.collection(`users/${uid}/menus`)

    // get menus date
    getMenusDate = (uid, week, day) => this.db.collection(`users/${uid}/menus/${week}/${day}`)

    // get menus content
    getMenusContent = (uid, week, day, date) => this.db.doc(`users/${uid}/menus/${week}/${day}/${date}`)

    //new day in menu week
    newDay = (uid, week, day, MenuData) => this.db.collection('users').doc(`${uid}`).collection('menus').doc(`${week}`).collection(`${day}`).doc(`${MenuData.date}`).set(MenuData)

    // update day
    deleteDay = (uid, week, day, Date) => this.db.collection('users').doc(`${uid}`).collection('menus').doc(`${week}`).collection(`${day}`).doc(`${Date}`).delete()

    // new week for customer
    newCustomerChoice = (uid, week, customer, day, MenuData, token) => this.db.collection('users').doc(`${uid}`).collection('customer').doc(`${customer}`).collection(`${week}`).doc(`${day}`).collection('Menu').doc(`${token}`).set(MenuData)
    
    // update taxation month
    updateTaxationMonth = (uid, customer, amount) => this.db.collection('users').doc(`${uid}`).collection('customer').doc(`${customer}`).collection(`taxation`).doc(`taxation`).update(amount)

    // new taxation month
    newTaxationMonth = (uid, customer, amount) => this.db.collection('users').doc(`${uid}`).collection('customer').doc(`${customer}`).collection(`taxation`).doc(`taxation`).set(amount)

    //check taxation month already have a value
    checkTaxationMonth = (uid, customer) => this.db.collection('users').doc(`${uid}`).collection('customer').doc(`${customer}`).collection(`taxation`).doc(`taxation`)

    // new week for customer
    newRecap = (uid, week, day, MenuData, token) => this.db.collection('users').doc(`${uid}`).collection('recap').doc(`${week}`).collection(`${day}`).doc(`${token}`).set(MenuData)

    // new week for customer
    getRecap = (uid, week, day, token) => this.db.collection('users').doc(`${uid}`).collection('recap').doc(`${week}`).collection(`${day}`).doc(`${token}`)

    // get all menuA from user
    getMenuNbr = (uid, week, customer, day) => this.db.collection(`users/${uid}/customer/${customer}/${week}/${day}/Menu`)

    // get all choices of a chosen day
    getDayChoices = (uid, week, day) => this.db.collection('users').doc(`${uid}`).collection('recap').doc(`${week}`).collection(`${day}`)

    //get customer choices
    getCustomerChoices = (uid, customer, week, day) => this.db.collection('users').doc(`${uid}`).collection('customer').doc(`${customer}`).collection(`${week}`).doc(`${day}`).collection('Menu')

    // get selected menu
    getSelectedChoice = (uid, customer, week, day, token) => this.db.collection('users').doc(`${uid}`).collection('customer').doc(`${customer}`).collection(`${week}`).doc(`${day}`).collection('Menu').doc(`${token}`)
}

export default Firebase